import http from "@services/httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { PagedResultDto } from "@services/dto/pagedResultDto"

const getSalePolicyAuditFieldLabels = (): Record<string, string> => ({
  ProjectId:    L("SALE_POLICY_DETAIL_PROJECT"),
  Name:         L("SALE_POLICY_DETAIL_NAME"),
  Description:  L("SALE_POLICY_DETAIL_NOTE"),
  FromDate:     L("PROMOTION_DETAI_START_DATE"),
  ToDate:       L("PROMOTION_DETAI_END_DATE"),
  IsActive:     L("LOAN_PROGRAM_DETAIL_IS_ACTIVE"),
  Type:         L("SALE_POLICY_DETAIL_TYPE"),
})

class SalePolicyService {
  public async create(body: any) {
    const res = await http.post("api/services/app/SalesPolicy/Create", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async update(body: any) {
    const res = await http.put("api/services/app/SalesPolicy/Update", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async active(id: number, isActive) {
    const res = await http.post(
      "api/services/app/SalesPolicy/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async bulkActive(id: number[]) {
    const res = await http.post("api/services/app/SalesPolicy/BulkActive", id)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/SalesPolicy/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }
  public async getList(params?): Promise<any> {
    const res = await http.get("/api/services/app/SalesPolicy/GetList", {
      params,
    })
    const { result } = res.data

    return result
  }
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/SalesPolicy/GetAll", {
      params,
    })
    return res.data.result
  }

  public async getListForAdmin(params: any): Promise<any[]> {
    const res = await http.get("api/services/app/SalesPolicy/GetListForAdmin", {
      ...params,
    })
    const { result } = res.data
    return result
  }

  public async getSalesPolicy(params: any): Promise<any> {
    const res = await http.get("api/services/app/Cart/GetSalesPolicy", {
      params,
    })
    return res.data.result
  }
  public async getSpecial(params: any): Promise<any> {
    const res = await http.get("api/services/app/SalesPolicy/GetSpecial", {
      params,
    })
    return res.data.result
  }
  public async getAuditLog(id: any) {
    const res = await http.get("api/services/app/SalesPolicy/GetAuditLogs", {
      params: { id },
    })
    const labels = getSalePolicyAuditFieldLabels()
    return (res.data.result || []).map((row: any) => {
      ;(row.items || []).forEach((item: any) => {
        item.propertyName = labels[item.propertyName] ?? item.propertyName
      })
      return row
    })
  }
}

export default new SalePolicyService()
